import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class VinImportService {

  static async getLastImport() {
    return http.get("/cfadminvinadmin/api/v1/vin-import",{ headers: await authHeader()});
  }

  static async getImportStatus() {
    return http.get("/cfadminvinadmin/api/v1/vin-import/status",{ headers: await authHeader()});
  }

  static async initiateVinImport(data: any) {
    return http.post(`/cfadminvinadmin/api/v1/vin-import`,data ,{ headers: await authHeader()});
  }

  static async getRulesApplyStatus() {
    return http.get("/cfadminvinadmin/api/v1/vin-pattern-apply-rules/status",{ headers: await authHeader()});
  }

  static async initiateRulesApply(data: any) {
    return http.post(`/cfadminvinadmin/api/v1/vin-pattern-apply-rules`,data ,{ headers: await authHeader()});
  }

  static async getVinFragments() {
    return http.get("/cfadminvinadmin/api/v1/unreconciled-vin-fragments",{ headers: await authHeader()});
  }

  static async getMissingRules() {
    return http.get("/cfadminvinadmin/api/v1/unreconciled-vin-fragments/missing-rules",{ headers: await authHeader()});
  }

  static async getVinFragmentAttributes(data: any) {
    return http.post("/cfadminvinadmin/api/v1/unreconciled-vin-fragments/attributes", data, { headers: await authHeader()});
  }

  static async getVehicleAttributeValues(data: any) {
    return http.post(`/cfadminvehicleconfig/api/v1/attribute-values-query/by-attribute-ids`, data, { headers: await authHeader()});
  }

  static async getVehicleSourceAttributeValues(attributedesc: any) {
    return http.get(`/cfadminvinadmin/api/v1/mapping-rules/source-attribute-values?attribute=${attributedesc}`, { headers: await authHeader()});
  }

  static async saveRule(data: any) {
    return http.post(`/cfadminvinadmin/api/v1/mapping-rules`, data, { headers: await authHeader()});
  }

  static async editRule(data: any, ruleId: any) {
    return http.put(`/cfadminvinadmin/api/v1/mapping-rules/rule-attributes/${ruleId}`, data, { headers: await authHeader()});
  }

  static async getInternalVins() {
    return http.get("/cfadminvinadmin/api/v1/manual-vin-pattern",{ headers: await authHeader()});
  }

  static async createInternalVin(data: any) {
    return http.post(`/cfadminvinadmin/api/v1/manual-vin-pattern`, data, { headers: await authHeader()});
  }

  static async updateInternalVin(data: any) {
    return http.put(`/cfadminvinadmin/api/v1/manual-vin-pattern`, data, { headers: await authHeader()});
  }

  static async deleteInternalVin(id: number) {
    return http.delete(`/cfadminvinadmin/api/v1/manual-vin-pattern?patternId=${id}`, { headers: await authHeader()});
  }

  static async updateFlag(data: any) {
    return http.put(`/cfadminvinadmin/api/v1/manual-vin-pattern/changeFlag`, data, { headers: await authHeader()});
  }

  static async getReleasePreprocessReport() {
    return http.get("/cfadminvinadmin/api/v1/release",{ headers: await authHeader()});
  }

  static async releaseVin(data: any) {
    return http.post(`/cfadminvinadmin/api/v1/release`, data, { headers: await authHeader()});
  }

  static async getRuleGroupIndex() {
    return http.get(`/cfadminvinadmin/api/v1/mapping-rules`, { headers: await authHeader()});
  }

  static async getRuleQueries(attribute : string, fordFlag : boolean) {
    return http.get(`/cfadminvinadmin/api/v1/mapping-rules/rules-query?attribute=${attribute}&fordFlag=${fordFlag}`, { headers: await authHeader()});
  }

  static async deleteRuleById(ruleId: any) {
    return http.delete(`/cfadminvinadmin/api/v1/mapping-rules/delete-rule-by-id/${ruleId}`, { headers: await authHeader()});
  }

  static async getRuleAttributesById(ruleId: any) {
    return http.get(`/cfadminvinadmin/api/v1/mapping-rules/rule-attributes?ruleId=${ruleId}`, { headers: await authHeader()});
  }

  static async getUnknownVinFragments(fromDate: Date) {
    const timestamp: string = fromDate.toISOString();
    return http.get(`/cfadminvinadmin/api/v1/error-vins?timestamp=${timestamp}`, { headers: await authHeader()});
  }

  static async handleSubmitVins(errorVins: any) {
    return http.post(`/cfadminvinadmin/api/v1/unreconciled-vin-pattern/processErrorVin`, errorVins, {headers: await authHeader()});
  }
}

export default VinImportService;